module.exports = __webpack_public_path__ + "img/Full-Lace-Wig18-Straight-Natural-Color.99e675f9.jpg";